export default {
  saveGridState: ({ commit }, payload) => {
    commit('SET_GRID_STATE', payload)
  },
  saveGridStateFromLocalStorage: ({ commit }, payload) => {
    commit('GET_GRID_STATE_LOCALSTORAGE', payload)
  }
}
